'use client';
import LogoSVG from '@/assets/icons/newLogoRed.svg';
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/25061';
import styles from './index.module.scss';
const HeaderLogo = () => {
  const handleLogo = () => {
    sendClickTrack.Header_Logo();
    const urlParams = new URLSearchParams(location.search);
    const returnUrl = urlParams.get('returnUrl');
    if (returnUrl && (returnUrl.startsWith('https://') || returnUrl.startsWith('http://'))) {
      try {
        const url = new URL(returnUrl);
        location.href = `${url.protocol}//${url.hostname}`;
      } catch (error) {
        console.error('Error header logo click', error);
        location.href = '/';
      }
    } else {
      location.href = '/';
    }
  };

  return (
    <button
      className={styles.logo}
      aria-label='Logo'
      exptag={'exp|' + EXPOSURE_RECORD.Header_Logo_Expo}
      data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
      onClick={handleLogo}
    >
      <LogoSVG width='110px' height='30px' />
      <div className={styles.beta}>Beta</div>
    </button>
  );
};

export default HeaderLogo;
